import React from 'react';

const PerjalananDinas = () => {
  return (
    <h1>Perjalanan Dinas</h1>
  );
};

export default PerjalananDinas;





